export default () => {
  let $filter_form = $('.affiliate-sales__filter__form');
  $('.affiliate-sales__filter__trigger').on('click', function(e){
      e.preventDefault();
      $filter_form.toggleClass('active');
  });

  $('input[name="filter_from"]').change(function() {
    $('input[name="filter_to"]').val($(this).val());
  });

  // selectWoo is WooCommerce's bundled fork of select2, already enqueued on this endpoint
  $('.status-select, .subscription-selector__select').selectWoo();
}
